import { ADDON_TYPE } from '@shootsta/common-domain-data';

const {
  RUSH_EDIT,
  BURN_IN_CAPTIONS,
  SRT_CAPTIONS,
  VOICE_OVER_ARTIST,
  ADDITIONAL_OUTPUT
} = ADDON_TYPE;

export const ABOUT_ADDON_OPTIONS = {
  [RUSH_EDIT]: {
    LINK_TEXT: 'What are rush edits?',
    MODAL: {
      TITLE: 'Rush Edits',
      DESCRIPTION: 'Have your edit back to you in half the time!'
    },
    VIDEO_NAME: 'RUSH_EDIT'
  },
  [BURN_IN_CAPTIONS]: {
    LINK_TEXT: 'What are burn in captions?',
    MODAL: {
      TITLE: 'Captions',
      DESCRIPTION: 'Add words to show what your video is saying!'
    },
    VIDEO_NAME: 'CAPTIONS'
  },
  [SRT_CAPTIONS]: {
    LINK_TEXT: 'What are SRT captions?',
    MODAL: {
      TITLE: 'Captions',
      DESCRIPTION: 'Add words to show what your video is saying!'
    },
    VIDEO_NAME: 'CAPTIONS'
  },
  [VOICE_OVER_ARTIST]: {
    LINK_TEXT: 'What is a voice over artist?',
    MODAL: {
      TITLE: 'Voice Overs',
      DESCRIPTION: 'Make your video sound a slick as it looks with a professional voice!'
    },
    VIDEO_NAME: 'VOICE_OVER_ARTIST'
  },
  [ADDITIONAL_OUTPUT]: {
    LINK_TEXT: 'What are social iterations?',
    MODAL: {
      TITLE: 'Social Iterations',
      DESCRIPTION: 'Shorter & Sweeter than the original!'
    },
    VIDEO_NAME: 'ADDITIONAL_OUTPUT'
  }
};